import { ApolloError } from '@apollo/client';

import { useToasts } from '@reckon-web/toast';

type Error = ApolloError | undefined;

export type HandleErrorType = {
  error?: Error | any;
  message?: string;
  title?: string;
  tone?: 'critical' | 'informative' | 'positive' | 'warning';
};

export const useError = () => {
  const { addToast } = useToasts();

  const genericError =
    'Oops something went wrong, error has been logged. Please contact customer support';

  const handleError = ({
    error,
    message,
    title,
    tone = 'critical',
  }: HandleErrorType) => {
    const messageText = message || error?.message || genericError;
    const titleText = title || error?.name || 'Error';
    const correlationId = getErrorCorrelationId(error);
    const correlationIdSuffix = correlationId
      ? `| Request ID: ${correlationId}`
      : '';
    const messageTextWithCorrelationIdSuffix =
      `${messageText} ${correlationIdSuffix}`.trim();

    addToast({
      message: messageTextWithCorrelationIdSuffix,
      title: titleText,
      tone,
    });
  };

  return handleError;
};

function getErrorCorrelationId(apolloError?: ApolloError): string {
  if (!apolloError?.graphQLErrors) {
    return '';
  }

  for (let graphQLError of apolloError.graphQLErrors) {
    return String(graphQLError.extensions?.correlationId || '');
  }

  return '';
}
